const configs = {
  WEB_URL: process.env.REACT_APP_WEB_URL,
  API_URL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV,
};

const googleServices = {
  CAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_CLIENT_KEY,
  TRACKING_ID: process.env.REACT_APP_TRACKING_ID,
};

const common = {
  CONNECTION_TIMEOUT: 30000,
  MAXIMUM_FILE_SIZE: 1024 * 1024 * 7, //7 MB
  WAITING_TIME: 5000, // 5 secs
  ANIMATION_TIME: 300,
};

const table = {
  ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100],
  ROWS_PER_PAGE: 10,
};

const textLength = {
  CODE_LENGTH: 16,
  TEXT_SHORT_LENGTH: 50,
  TEXT_MEDIUM_LENGTH: 100,
  TEXT_MAX_LENGTH: 255,
  VERIFICATION_CODE_LENGTH: 6,
};

const AWS_CONFIG = {
  region: process.env.REACT_APP_AWS_IDENTITY_REGION,
  userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  oauth: {
    domain: process.env.REACT_APP_AWS_USER_POOL_DOMAIN,
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: process.env.REACT_APP_WEB_URL + '/signin',
    redirectSignOut: process.env.REACT_APP_WEB_URL + '/signin',
    responseType: 'code',
  },
};

const PERMISSIONS = {
  DASHBOARD_PERMISSION: [],
  EXEMPTION_PERMISSION: ['EXEMPTION:R', 'EXEMPTION:U', 'EXEMPTION:D'],
  EXEMPTION_MED_PERMISSION: ['EXEMPTION_MED:R', 'EXEMPTION_MED:U'],
  EXEMPTION_CIQR_PERMISSION: ['EXEMPTION_CIQR:R', 'EXEMPTION_CIQR:U'],
  TRIP_PERMISSION: ['TRIP:U', 'TRIP:D'],
  USER_PERMISSION: ['USER:C', 'USER:R', 'USER:U', 'USER:D'],
  TESTING_PERMISSION: ['TESTING:C', 'TESTING:R', 'TESTING:U', 'TESTING:D'],
  REPORT_PERMISSION: ['REPORT:R'],
  HEALTH_PERMISSION: ['HEALTH:R'],
};

export default {
  ...configs,
  ...googleServices,
  ...common,
  ...textLength,
  ...table,
  ...PERMISSIONS,
  AWS_CONFIG,
};
